export default "Simulez les aides MaPrimeRénov’ Copropriété, CEE collectifs et éco-PTZ pour votre immeuble. Résultat par logement, prêt pour l'assemblée générale.";
